import { render, staticRenderFns } from "./OpmerkingForm.vue?vue&type=template&id=9e92ca1a&scoped=true"
import script from "./OpmerkingForm.vue?vue&type=script&lang=js"
export * from "./OpmerkingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e92ca1a",
  null
  
)

export default component.exports